<template>
  <div class="container">
    <div class="module_section1">
      <div class="banner_cont">
        <div class="title">储能电池数据监测平台</div>
        <div class="subtitle1">实时监测&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;云端运维&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;AI增强&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;全生命周期安全保障</div>
      </div>
    </div>
    <div class="module_section2 module">
      <!-- <img class="kIcon" src="https://oss.duodians.com/lambda/office_web/solution/k_icon.png" alt=""> -->
      <div class="overview_cont">
        <div class="overview_left">
          <p class="title">储能电池数据监测平台</p>
          <p class="text">严格遵循全生命周期理念，实时采集电池内电压、温度、内阻、报警等数据，实现准确监控和云端运维，全面保障电池安全与寿命；</p>
          <p class="text">针对动力电池储能项目，建立电池一致性管理和溯源系统，实时监测电池性能参数，定期进行维护和安全评估，通过大数据电池AI预警，协助用户做好应急预案。</p>
        </div>
        <div class="overview_right">
          <img src="https://oss.duodians.com/lambda/office_web/platform/section_right.png" alt="">
        </div>
      </div>
    </div>
    <div class="module_section3">
      <p class="title_com">产品优势</p>
      <div class="advantage_cont module">
        <div class="item" v-for="(el, ind) in advantageList" :key="ind">
          <img class="icon" :src="el.icon" alt="">
          <div class="right">
            <p class="title">{{ el.title }}</p>
            <p class="text">{{ el.text }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="module_section4">
      <p class="title_com" style="color: #fff">产品功能</p>
      <div class="function_cont module">
        <div class="left">
          <img src="https://oss.duodians.com/lambda/office_web/platform/function_big01.jpg" alt="">
          <p class="text">遵循全生命周期理念，实现电池远程监控和云端运维</p>
        </div>
        <div class="right">
          <img src="https://oss.duodians.com/lambda/office_web/platform/function_big02.png" alt="">
          <p class="text">采用Energy AI技术，全面监测和评估电池，保障储能资产</p>
        </div>
      </div>
    </div>
    <div class="module_section5">
      <p class="title_com">储能安全的大数据AI预警</p>
      <div class="technology_cont module">
        <div class="item" v-for="(el, ind) in technologyList" :key="ind">
          <div v-if="ind % 2 === 0" class="left">
            <img class="icon" :src="el.icon" alt="">
            <div class="cont">
              <p class="title">{{ el.title }}</p>
              <p class="text" v-for="(e, i) in el.list" :key="i">{{ e }}</p>
            </div>
          </div>
          <div v-if="ind % 2 === 1" class="right">
            <div class="cont">
              <p class="title">{{ el.title }}</p>
              <p class="text" v-for="(e, i) in el.list" :key="i">{{ e }}</p>
            </div>
            <img class="icon" :src="el.icon" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      advantageList: [{
        icon: 'https://oss.duodians.com/lambda/office_web/platform/advantage_icon01.png',
        title: 'AI安全算法',
        text: '通过Battery AI技术，可对电池内短路和热失控等严重故障进行AI预警，并定期进行电池安全AI健康评估，保障储能安全'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/platform/advantage_icon02.png',
        title: 'AI一致性算法',
        text: '基于储能大数据提出电池一致性系数，准确计算与评估电池的一致性水平'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/platform/advantage_icon03.png',
        title: '全生命周期理念',
        text: '遵循电池全生命周期理念，支持电池溯源，满足监管要求；实现储能安全事故的黑匣子功能'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/platform/advantage_icon04.png',
        title: '电芯级精准监控与预测',
        text: '重要电池性能参数可实现电芯级的监控和预测，精准反应电池异常'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/platform/advantage_icon05.png',
        title: '多场景适用',
        text: '适用于储能站、换电站、光储充站、动力电池梯次利用等多业务场景'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/platform/advantage_icon06.png',
        title: '高稳定性',
        text: '支持数百GWh级电池同步在线管理；支持多终端数据接入和实时在线处理 '
      }],
      technologyList: [{
        icon: 'https://oss.duodians.com/lambda/office_web/platform/technology_big01.jpg',
        title: '电池热失控引起的事故频发，带来巨大损失',
        list: ['在国家政策的推动下，储能电站正如火如荼地推动建设中。然而，储能电站爆炸的新闻给储能行业敲响了警钟，储能电站的安全问题不容小觑。究其背后，爆炸直接原因为电池内的单体电芯发生内短路故障，引发电池及电池模组热失控扩散起火，故产生的易燃易爆成分与空气混合形成爆炸性气体，遇电气火花发生爆炸']
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/platform/technology_big02.jpg',
        title: '内短路与热失控的AI预警技术保障储能安全',
        list: ['热失控严重威胁着电池安全。结合电化学与AI技术，对内短路与电池热失控风险评估、热失控数据分析与智能防护等课题进行持续深入的研究，形成了一系列热失控的核心技术']
      }],
    };
  },
  components: {},

  computed: {},

  methods: {
  }
};
</script>
<style lang='less' scoped>
.container{
  position: relative;
  top:-80px;
  z-index: 1;
  .module{
    width:1300px;
    margin: 0 auto;
  }
  .title_com{
    font-size: 46px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    text-align: center;
    color: #000000;
    line-height: 66px;
    padding: 100px 0 12px;
  }
  .subTile_com{
    margin: 0 auto 0;
    width: 800px;
    height: 62px;
    opacity: 0.6;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #000000;
    line-height: 30px;
  }
  .module_section1{
    height: 630px;
    background: url('https://oss.duodians.com/lambda/office_web/platform/section1_bg.jpg');
    background-size: 100% 100%;
    .banner_cont{
      padding-top: 162px;
      .title{
        font-size: 48px;
        font-family: Source Han Sans CN, Source Han Sans CN-Bold;
        font-weight: 700;
        text-align: center;
        color: #ffffff;
        line-height: 48px;
      }
      .subtitle1{
        margin: 50px auto 0;
        width: 932px;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 30px;
      }
      .btn{
        margin: 50px auto 0;
        width: 200px;
        height: 50px;
        border: 2px solid;
        border-radius: 28px;
        border-image: linear-gradient(270deg, #4add69 18%, #4cddbd 58%, #3cecf0 43%, #12ee90 99%) 2 2;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: #4cddbd;
      }
    }
  }
  .module_section2{
    margin-top: -140px;
    height: 540px;
    border-radius: 30px;
    background: url('https://oss.duodians.com/lambda/office_web/solution/section2_bg.png') #f6fafd ;
    background-size: 100% 100%;
    position: relative;
    .kIcon{
      position: absolute;
      width: 131px;
      top: 74px;
      left: 120px;
    }
    .overview_cont{
      position: absolute;
      z-index: 2;
      width:980px;
      margin: 40px 0 0 170px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .overview_left{
        width:440px;
        .title{
          font-size: 36px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #000000;
        }
        .subTitle{
          font-size: 26px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #000000;
          line-height: 34px;
          margin-top: 14px;
        }
        .text{
          margin-top: 33px;
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: justify;
          color: #000000;
          line-height: 28px;
          letter-spacing: 0.08px;
        }
      }
      .overview_right{
        img{
          width:476px;
          height: 460px;
        }
      }
    }
  }
  .module_section3{
    margin-top: 100px;
    height: 960px;
    background: #f6fafd;
    .advantage_cont{
      margin-top: 60px;
      display: flex;
      flex-wrap: wrap;
      .item{
        width: 634px;
        height: 190px;
        background: #ffffff;
        border-radius: 8px;
        margin: 0 32px 34px 0;
        padding: 45px 40px 0;
        text-align: center;
        display: flex;
        .icon{
          width: 100px;
          height: 100px;
          margin-right: 40px;
        }
        .right{
          text-align: left;
        }
        .title{
          font-size: 26px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          color: #303132;
          line-height: 32px;
          margin-bottom: 5px;
        }
        .text{
          margin-top: 18px;
          font-size: 18px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          color: #303132;
          line-height: 24px;
        }
      }
      .item:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
  .module_section4{
    height: 960px;
    background: url('https://oss.duodians.com/lambda/office_web/platform/section4_bg.jpg') #f6fafd ;
    background-size: 100% 100%;
    .function_cont{
      margin-top: 99.5px;
      display: flex;
      .left, .right{
        width:631px;
        position: relative;
        .text{
          position: absolute;
          bottom: 30.5px;
          font-size: 20px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 500;
          text-align: center;
          color: #ffffff;
          line-height: 30px;
          text-align: center;
          width:100%;
        }
      }
      .left{
        margin-right: 38px;
      }
      img{
        width:100%;
      }
    }
  }
  .module_section5{
    height: 1326px;
    background: #f6fafd;
    margin-bottom: -80px;
    .technology_cont{
      padding-top: 100px;
      .item{
        height: 440px;
        border-radius: 8px;
        margin: 0 32px 34px 0;
        margin-bottom: 80px;
        .left, .right{
          display: flex;
          align-items: center;
        }
        .icon{
          width: 650px;
          height: 440px;
        }
        .cont{
          width: 556px;
          .title{
            font-size: 30px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            text-align: left;
            color: #000000;
            line-height: 44px;
            margin-bottom: 60px;
          }
          .text{
            font-size: 20px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: justify;
            color: #303132;
            line-height: 28px;
            letter-spacing: 0.09px;
          }
        }
        .left{
          .icon{
            margin-right: 100px;
          }
        }
        .right{
          .icon{
            margin-left: 100px;
          }
        }
      }
      .item:last-child{
        margin-bottom: 0;
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/platform/platform.vue